import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import List from 'components/List'
import InputNumber from 'components/InputNumber'
import { CONSTANTS } from 'constants/constants'
import { EXPERIENCE } from 'constants/forioVariables'
import { changeVariable } from 'actions/experienceActions'
import { changeValue as onChangeValue } from 'common'

const { DECISIONES_HORAS_LABORALES_EXIGIDAS_A_DIRECTORES } = EXPERIENCE
const { DIRECTOR_SHIFT_HOURS } = CONSTANTS

const returnElements = (variables, changeValue) => [
  {
    id: '1-DirectorShiftLengthInHours',
    label: DIRECTOR_SHIFT_HOURS,
    component: (
      <InputNumber
        defaultValue={variables[DECISIONES_HORAS_LABORALES_EXIGIDAS_A_DIRECTORES]}
        id={DECISIONES_HORAS_LABORALES_EXIGIDAS_A_DIRECTORES}
        change={event => changeValue(event)}
        max={24}
      />
    ),
  },
]
const DirectorShiftLengthInHours = () => {
  const dispatch = useDispatch()
  const variables = useSelector(state => state.experience.currentValues.variablesBurnout)

  const changeValue = onChangeValue('variablesBurnout', dispatch, changeVariable)

  return <List items={returnElements(variables, changeValue)} />
}
export default DirectorShiftLengthInHours
